import Vue from 'vue'
import VueRouter from 'vue-router'
import moment from 'moment'
import 'moment/locale/ru'
import VueMoment from 'vue-moment'
import VuePageTitle from 'vue-page-title'
import { Notification } from 'uiv'
import App from './App.vue'
import router from './router'
import store from './store'
import eventBus from './eventBus'
import constants from './plugins/constants'
import { formatSize, capitalizeFirstLetter } from './helper'
import context from '../../Modules/Context/Resources/assets/js'
import serm from '../../Modules/Serm/Resources/assets/js'
import seo from '../../Modules/Seo/Resources/assets/js'
import registerModules from './registerModules'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'admin-lte/dist/css/AdminLTE.min.css'
import 'font-awesome/css/font-awesome.min.css'
import 'pace-progressbar/themes/blue/pace-theme-minimal.css'
import 'source-sans-pro/source-sans-pro.css'

import 'bootstrap'
import 'admin-lte'
import 'pace-progressbar'

import '../css/style.scss'

const VueInputMask = require('vue-inputmask').default

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueMoment, {
  moment
})
Vue.use(constants)
Vue.use(VueInputMask)
Vue.use(VuePageTitle, {
  suffix: '- ЛК',
  router
})
Vue.filter('formatSize', formatSize)
Vue.filter('capitalizeFirstLetter', capitalizeFirstLetter)

registerModules({
  context,
  serm,
  seo
})

window.vue = new Vue({
  components: {
    Notification
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')

eventBus.listen()
